import { gql } from "@apollo/client";

export const AdditionalFlexibleContentFragment = gql`
  fragment AdditionalFlexibleContent on CeremonyLanding {
    additionalFlexibleContent {
      ... on CeremonyLandingAdditionalFlexibleContentCarouselShopLayout {
        headline
        type
        shopifyCollection
        shopifyTag
        searchValue
        cta {
          linkType
          label
          externalLink
          page {
            node {
              uri
            }
          }
        }
      }
      ... on CeremonyLandingAdditionalFlexibleContentFloatSpotlightLayout {
        eyebrow
        headline
        smallText
        cta {
          linkType
          externalLink
          label
          page {
            node {
              uri
            }
          }
        }
        secondaryCta {
          linkType
          externalLink
          label
          page {
            node {
              uri
            }
          }
        }
        images {
          topLeft {
            ...ACFMedia
          }
          top {
            ...ACFMedia
          }
          topRight {
            ...ACFMedia
          }
          bottomLeft {
            ...ACFMedia
          }
          bottomRight {
            ...ACFMedia
          }
        }
      }
      ... on CeremonyLandingAdditionalFlexibleContentTitleLayout {
        headline
      }
      ... on CeremonyLandingAdditionalFlexibleContentFeatureLayout {
        headline
        float
        items {
          body
          ctaLabel
          headline
          linkType
          pillLabel
          image {
            ...ACFMedia
          }
          externalLink
          page {
            node {
              databaseId
              __typename
              uri
              ... on Event {
                ...EventFragment
              }
            }
          }
        }
      }
      ... on CeremonyLandingAdditionalFlexibleContentBannerLayout {
        type
        largeBorder
        eyebrow
        headline
        subhead
        link {
          linkType
          externalLink
          page {
            node {
              uri
            }
          }
        }
      }
    }
  }
`;